import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Drawer } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarService } from '../../Services/sidebar.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterLink, RouterLinkActive, Drawer, TooltipModule],
  templateUrl: './sidebar.html',
})
export class Sidebar {
  public sidebarService = inject(SidebarService);

  @Input() drawerOpen: boolean = false;
  @Output() drawerOpenChange = new EventEmitter<boolean>();
}
